/**
 * Admin Architecture & Operations handbook.
 * Facts below are taken from the repository as of 2026-08-31.
 * Items that cannot be read from source control are marked unknown.
 */

export const DOC_META = {
  lastReviewed: 'August 31, 2026',
  repoUrl: 'https://github.com/ltcastro/thriveLonger5_30_26',
  repoOwner: 'ltcastro (Lyndon T. Castro)',
  defaultBranch: 'main',
};

export const SECTIONS = [
  { id: 'architecture', title: 'Website Architecture and Source Code' },
  { id: 'hosting', title: 'Hosting and Deployment' },
  { id: 'dns', title: 'Domain and DNS' },
  { id: 'database', title: 'Database and User Information' },
  { id: 'stripe', title: 'Stripe and Payment Processing' },
  { id: 'apis', title: 'Every API and Outside Service' },
  { id: 'expenses', title: 'Recurring and Usage-Based Expenses' },
  { id: 'email', title: 'Emails and Communications' },
  { id: 'accounts', title: 'User Accounts and Administration' },
  { id: 'ai', title: 'AI Functionality' },
  { id: 'security', title: 'Security' },
  { id: 'affiliates', title: 'Affiliate / E-Commerce Architecture' },
  { id: 'design', title: 'Design and Content' },
];
